import { module } from 'angular';

import { default as syntheticName, Synthetic } from './synthetic.component.ajs';

export default module('hypervision.skill-view.synthetic', []).component(syntheticName, new Synthetic()).name;
